export default __webpack_public_path__ + "static/screen_1_08.js-339736b39d15c58cdb9162d7b82fd0f4.svg";